import { Environment } from '@nimmsta/ng-commons-lib/config';

export const environment = {
  production: true,
  environment: Environment.STAGING,
  apiUrls: {
    b2b: 'https://backend.staging.b2b.nimmsta-test.de',
    workflow: 'https://backend.staging.cloud.nimmsta-test.de',
    configurations: 'https://backend.staging.configurator.nimmsta-test.de',
    auth: 'https://auth.staging.nimmsta-test.de',
  },
  applicationUrls: {
    configurations: 'https://staging.configurator.nimmsta-test.de',
    workflow: 'https://staging.cloud.nimmsta-test.de',
    documentation: 'https://devdocs.nimmsta.com/platform',
  },
  defaultPageSize: 20,
  defaultPageSizeOptions: [10, 20, 50, 100],
  ORG_ID_KEY: 'org_id',
  ROLE_KEY: 'role',
  USER_KEY: 'user_object',
  IMPERSONATION_KEY: 'impersonation_data',
  IMPERSONATION_BROADCAST_CHANNEL_NAME: 'channel-impersonation-data',
  PRODUCT_FRUITS_KEY: 'eSPpYe2bbFm1erLH',
  documentation1Url: 'https://devdocs.nimmsta.com/platform/',
  documentation2Url: 'https://docs.nimmsta.com',
  defaultConfigurationVersion: 7,

  keycloakUrl: 'https://auth.staging.nimmsta-test.de',
  keycloakRealm: 'productivity-cloud',
  keycloakClientId: 'platform',

  discoveryDocument: 'https://discovery.nimmsta.com/index.json',

  androidAppSoftwareId: '17f85f34-1cab-480a-bc17-8050ec26f8d4',
};
